<template>
  <div class="card mb-4">
    <div class="card-header navbar">
      <div class="pt-1">
        <i class="fas fa-chart-area me-1"></i>
        <span class="h5 ">歷史紀錄</span>
      </div>
      <ul class="nav nav-tabs card-header-tabs">
        <li class="nav-item" v-for="unit, index in time_unit" :key="index">
          <a href="#" class="nav-link" :class="{ 'active': timeFormat == unit }" @click="timeFormatSwitch(unit)">
            {{ timeUnitSwitch(unit) }}
          </a>
        </li>
      </ul>
    </div>
    <div class="card-body p-0">
      <do-canvas class="historical-chart"></do-canvas>
    </div>
  </div>
</template>

<script>
import DoCanvas from './DoCanvas.vue';
export default {
  components: { DoCanvas },
  data() {
    return {
      base_url,
      time_unit: ['day', 'week', 'month', 'year'],
    }
  },
  computed: {
    timeFormat() {
      return this.$store.getters.historicalDataTimeFormat;
    }
  },
  methods: {
    timeFormatSwitch(time_format) {
      this.$store.commit('setHistoricalDataTimeFormat', time_format);
    },
    timeUnitSwitch(unit) {
      switch (unit) {
        case "year":
          return "年"
        case "month":
          return "月"
        case "week":
          return "週"
        default:
          return "日"
      }
    }
  }
}
</script>

<style>
.historical-chart {
  padding: 1.5rem 0 0 0;
}

@media (min-width: 768px) {
  .historical-chart {
    padding: 1.25rem;
  }
}
</style>
